<script setup lang="ts">
import { Toaster } from '@laam/ui/base';
</script>

<template>
	<div>
		<Toaster :show-close="false"></Toaster>
		<slot />
	</div>
</template>
